// extracted by mini-css-extract-plugin
export default {"msgM":"_23c3902f7f"};